<div class="register-number-outer-container">

  <div class="info-container">
    <div class="headings-container">
      <div class="heading">
        <adp-label labelKey="Onboarding_ConfirmNumber_Heading"></adp-label>
      </div>
      <div class="subheading">
        <adp-label labelKey="RegisterNumber_Subheading"></adp-label>
      </div>
    </div>
    <div modal-body>

      <div>

        <div>
        <div class="row">
          <div modal-body class="mt-30 mb-30" style="align-items:center;">
            <form [formGroup]="updatePhoneInfoForm" name="updatePhoneInfoFormGroup">
              <div class="row">
                  <adp-input matInput class="field-input w-100"
                    [resourceData]="resourceService.getResourceObject('Onboarding_Diagnostic_ExtraInfo_PhoneNumber_Field')"
                    formControlName="mobileNumber"></adp-input>
              </div>
              <div style="text-align:left !important;margin-bottom:25px;margin-top:-10px;">
                <mat-checkbox matInput formControlName="differentMobileNumber" (change)="onCheckboxChanged($event)"><adp-label labelKey="Onboarding_Diagnostic_ExtraInfo_MobileNumber_Checkbox"></adp-label></mat-checkbox>
              </div>
            </form>
          </div>
        </div>
        </div>

        <div modal-footer fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="24px" fxLayoutGap.lt-sm="12px" class="mt-3">
          <div style="width:100%;text-align:center;" class="button-container-mobile">
            <button mat-flat-button style="border-radius: 6px !important;width:70%;" color="accent" (click)="handleConfirmNumber()"><adp-label labelKey="Global_Button_Next"></adp-label></button>
          </div>
        </div>

        </div>

    </div>
  </div>
</div>
